import { PropertyMapper } from '../../decorators';

export class StatusBase {
    @PropertyMapper()
    public id: number;

    @PropertyMapper()
    public name: string;
}
